import sliceCreator from '../../index.js';
import {EDIT_RAW_MATERIALS_BY_MACHINE} from '../../../constants/index.js';
const _putrawMaterialMachineMappingAction = sliceCreator('EDIT_RAW_MATERIALS_BY_MACHINE', EDIT_RAW_MATERIALS_BY_MACHINE, 'put');

const { asyncAction: putRawMaterialMachineMappingAction, reducer, clearData: clearPutRawMaterialMachineMappingAction } = _putrawMaterialMachineMappingAction;

export default reducer;

export {
    putRawMaterialMachineMappingAction,
    clearPutRawMaterialMachineMappingAction
}